module.exports = __webpack_public_path__ + "static/media/our-proejcts-img2.c3aec40c.png";